import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  all: [],
};

export default function teamReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.TEAMS_FETCH:
      return {
        ...state,
        all: payload,
      };
    default:
      return state;
  }
}
